import React from 'react';
export function Logo({
  className = '',
  width = 180,
  white = false
}: {
  className?: string;
  width?: number;
  white?: boolean;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/mCqChw2wGfpjtkDwptMCMB/Marca_con_fondo_transparente-removebg-preview.png" alt="El Código del Bienestar" width={width} style={{
    width: `${width}px`,
    height: 'auto',
    border: 'none',
    outline: 'none',
    filter: white ? 'brightness(0) invert(1)' : 'none'
  }} className={`block border-0 outline-none ${className}`} data-id="element-112" />;
}